import { render, staticRenderFns } from "./vincularWizard.vue?vue&type=template&id=584a819c&scoped=true"
import script from "./vincularWizard.vue?vue&type=script&lang=js"
export * from "./vincularWizard.vue?vue&type=script&lang=js"
import style0 from "./vincularWizard.vue?vue&type=style&index=0&id=584a819c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584a819c",
  null
  
)

export default component.exports